import React from 'react'
import { useAuthContext } from '../../Context'
import { PageContainer, Box } from '../../Components/Layout'
import { PLL_IMAGES } from '../../Config/config'
import { GeneralAppCallout } from '../../Components/Layout/Overlays/AppCallouts/GeneralAppCallout'
import { createProfileDynamicLink } from '../../Utils/links/dynamicLinkHelpers'
import { Spinner } from '../../Components/Icons'
import { colors } from '../../Components/consts'
import { UserProfile } from './components/Profile'
import { ProfileName } from './components/ProfileName'
import { FavTeam } from './components/FavTeam'
import { LoginBtn, LoginCon, UserInfoCon } from './components/styles'
import { Con } from '../../Components/Layout/Containers/ConStyles'
import { Img } from '../../Components/Image/Img'
import { DEFAULT_EXTRA_LOGIN_FIELDS } from '../../Api'
import { Lk } from '../../Components/Links/Lk'

const Login: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { isAnonymous, isLoggedIn, authLoading, login, logout } = useAuthContext()

  return (
    <>
      <GeneralAppCallout
        text={`Update your profile in the PLL App`}
        appLink={createProfileDynamicLink()}
        location={`Login_Page`}
      />
      <PageContainer>
        <Box>
          <LoginCon>
            {isLoggedIn && !isAnonymous && (
              <>
                <div className="logoutCon">
                  <button className="logoutInner" onClick={logout}>
                    Logout
                  </button>
                </div>
                <UserInfoCon>
                  <UserProfile />
                  <ProfileName />
                  <FavTeam />
                  <Lk link="/" alt="Go Home">
                    Go Home
                  </Lk>
                </UserInfoCon>
              </>
            )}
            {(!isLoggedIn || isAnonymous) && (
              <>
                <Img src={PLL_IMAGES.pllShield} alt="Pll logo" />
                <h3>Join The PLL</h3>
                <p>Keep up to date with your favorite team and players</p>
                <p>Gain access to exclusives</p>
                <p>Personalize your experience</p>
                {authLoading && (
                  <Con noMargin noPadding justify="center" align="center">
                    <Spinner width={30} fill={colors.yellow} />
                  </Con>
                )}
                {!authLoading && (
                  <LoginBtn onClick={() => login(DEFAULT_EXTRA_LOGIN_FIELDS)}>
                    Login
                  </LoginBtn>
                )}
              </>
            )}
          </LoginCon>
        </Box>
      </PageContainer>
    </>
  )
}

export default Login
